import { PsychoCardSkeleton } from './PsychoCardSkeleton';

const SKELETON_COUNT = 5;

export const PsychologistStepSkeleton = (): React.ReactElement => (
  <div className="flex flex-col gap-4">
    {Array.from({ length: SKELETON_COUNT }, (_item, index) => (
      <PsychoCardSkeleton key={index} />
    ))}
  </div>
);
